import ApiService from "@/core/services/api.service";
import { SET_PAGE_LOADING } from "@/core/services/store/config.module";

// action types
export const UPDATE_TABLE_STRUCTURE = "getSKUMOVEMENTTableStructure";
export const UPDATE_TABLE_DATA = "updateSKUMOVEMENTTableData";
export const EXPORT_TABLE_DATA = "exportSKUMOVEMENTTableData";

// mutation types
export const SET_TABLE_STRUCTURE = "setSKUMOVEMENTTableStructure";
export const SET_TABLE_DATA = "setSKUMOVEMENTTableData";
export const SET_TABLE_FILTER = "setSKUMOVEMENTTableFilter";
export const SET_TABLE_PAGE = "setSKUMOVEMENTTablePage";
export const SET_TABLE_PERPAGE = "setSKUMOVEMENTTablePerPage";
export const SET_TABLE_SORTBY = "setSKUMOVEMENTTableSortBy";
export const SET_TABLE_SORTORDER = "setSKUMOVEMENTTableSortOrder";
export const SET_EXPORT_LINK = "setSKUMOVEMENTExportLink";

const state = {
  export_link: null,
  table_structure: {},
  table_data: {},
  table_state: {
    page: 1,
    per_page: 50,
    sortBy: "id",
    sortOrder: "desc",
    filters: [],
  },
};

const getters = {
  /**
   * for table title, description
   * */
  getSKUMOVEMENTTableProperties(state) {
    return state.table_structure.properties;
  },
  /**
   * for table permissions
   **/
  getSKUMOVEMENTTablePermissions(state) {
    return state.table_structure.permissions;
  },
  getSKUMOVEMENTTableState(state) {
    // console.log("table state is ", state.table_state);
    return state.table_state;
  },

  getSKUMOVEMENTTableHeaders(state) {
    return state.table_structure.columns;
  },

  getSKUMOVEMENTTableFilters(state) {
    return state.table_structure.filters;
  },

  getSKUMOVEMENTTableData(state) {
    return state.table_data.data;
  },

  getSKUMOVEMENTExportUrl(state) {
    return state.export_link;
  },
  getSKUMOVEMENTUploadType(state) {
    return state.table_structure.type;
  },
};

const actions = {
  [UPDATE_TABLE_STRUCTURE](context) {
    // console.log(payload);
    return new Promise((resolve) => {
      ApiService.post("/warehouse_management/sku_movements")
        .then(({ data }) => {
          context.commit(SET_TABLE_STRUCTURE, data);
          context.commit(SET_PAGE_LOADING, false);
          resolve(data);
        })
        .catch((data) => {
          context.commit(SET_PAGE_LOADING, false);
          resolve(data);
        });
    });
  },
  [UPDATE_TABLE_DATA](context, payload) {
    context.commit(SET_PAGE_LOADING, true);
    return new Promise((resolve) => {
      // ApiService.post("login", credentials)
      ApiService.post("/warehouse_management/sku_movements/datatable", payload)
        .then(({ data }) => {
          // console.log("data of datatable ", data);
          context.commit(SET_TABLE_DATA, data);
          resolve(data);
          context.commit(SET_PAGE_LOADING, false);
          setTimeout(() => {
            window.scrollTo(0, 0);
          }, 100);
        })
        .catch((data) => {
          context.commit(SET_PAGE_LOADING, false);
          resolve(data);
        });
    });
  },
  [EXPORT_TABLE_DATA](context, payload) {
    context.commit(SET_PAGE_LOADING, true);
    return new Promise((resolve) => {
      ApiService.post("/warehouse_management/sku_movements/export", payload)
        .then(({ data }) => {
          // console.log("export data is ", data);
          context.commit(SET_EXPORT_LINK, data.url);
          resolve(data);
        })
        .catch((data) => {
          context.commit(SET_PAGE_LOADING, false);
          resolve(data);
        });
    });
  },
};

const mutations = {
  [SET_TABLE_FILTER](state, filter) {
    state.table_state.filters = filter;
  },
  [SET_TABLE_PAGE](state, page) {
    state.table_state.page = page;
  },
  [SET_TABLE_PERPAGE](state, perPage) {
    state.table_state.per_page = perPage;
  },
  [SET_TABLE_SORTBY](state, sortBy) {
    state.table_state.sortBy = sortBy;
  },
  [SET_TABLE_SORTORDER](state, sortOrder) {
    state.table_state.sortOrder = sortOrder;
  },
  [SET_TABLE_STRUCTURE](state, table_structure) {
    state.table_structure = table_structure.data;
  },
  [SET_TABLE_DATA](state, table_data) {
    state.table_data = table_data;
  },
  [SET_EXPORT_LINK](state, link) {
    state.export_link = link;
  },
};

export default {
  state,
  actions,
  mutations,
  getters,
};
